import postWithToken from './base/post-with-token'

const customerAddAction = (id, data) => postWithToken(`/customer/${id}/timeline/action`)(data)

export default customerAddAction